/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable no-console */
import {Util} from 'yougile-util'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'

interface ExpandedElems {
  name: string
  url: string
  width: number
}

export class TrainingController {
  private static addExpandImage(): void {
    const expandCnt = document.querySelector<HTMLElement>('.img-expand__cnt')
    if (!expandCnt) {
      return
    }

    const imgEl = expandCnt.querySelector('img')
    const nameEl = expandCnt.querySelector('.img-expand__name')
    const close = expandCnt.querySelector('.img-expand__close')
    const overlay = expandCnt.querySelector('.img-expand__overlay')
    const nextCnt = expandCnt.querySelector<HTMLElement>(
      '.img-expand__next-cnt'
    )
    const prevCnt = expandCnt.querySelector<HTMLElement>(
      '.img-expand__prev-cnt'
    )
    let currentIx = 0
    let isOpen = false

    const closeExpand = () => {
      document.body.classList.remove('blur')
      expandCnt.style.display = 'none'
      isOpen = false
    }
    close.addEventListener('click', closeExpand)
    overlay.addEventListener('click', closeExpand)

    const expands: ExpandedElems[] = []
    const openExpand = () => {
      isOpen = true
      document.body.classList.add('blur')
      const len = expands.length
      nextCnt.style.display = len > 0 && currentIx < len - 1 ? 'flex' : 'none'
      prevCnt.style.display = len > 0 && currentIx > 0 ? 'flex' : 'none'
      const exp = expands[currentIx]
      nameEl.textContent = exp.name
      imgEl.src = ''
      imgEl.style.maxWidth = Math.min(exp.width || 900, 900) + 'px'
      imgEl.src = exp.url
      expandCnt.style.display = 'block'
    }
    const goNext = (): void => {
      if (currentIx + 1 >= expands.length) {
        return
      }
      currentIx++
      openExpand()
    }
    const goPrev = (): void => {
      if (currentIx <= 0) {
        return
      }
      currentIx--
      openExpand()
    }
    nextCnt.addEventListener('click', goNext)
    prevCnt.addEventListener('click', goPrev)
    document.addEventListener('keyup', e => {
      if (!isOpen) {
        return
      }
      if (e.key === 'ArrowLeft') {
        goPrev()
      } else if (e.key === 'ArrowRight') {
        goNext()
      } else if (e.key === 'Escape') {
        closeExpand()
      }
    })
    const wrap = (el: HTMLElement, ix: number): void => {
      const wrapper = document.createElement('div')
      wrapper.classList.add('img-expand__wrap')
      el.after(wrapper)
      el.remove()
      wrapper.appendChild(el)
      wrapper.addEventListener('click', () => {
        currentIx = ix
        openExpand()
      })
    }

    const expandEls = document.querySelectorAll<HTMLElement>('[data-expand]')
    for (const el of Util.iter(expandEls)) {
      const url = el.dataset.expand
      const name = el.dataset.expandName ?? ''
      const width = +el.dataset.expandWidth || undefined
      const ix = expands.push({name, url, width}) - 1
      wrap(el, ix)
    }
    const wnd = window as any
    wnd.expands = expands
  }

  private static addVideoPopup(): void {
    const vidCnt = document.querySelector<HTMLElement>('.vid__video-cnt')
    if (!vidCnt) {
      return
    }

    const overlay = vidCnt.querySelector('.vid__video-overlay')
    const close = document.querySelector('.vid__video-close')
    const iframe = vidCnt.querySelector('iframe')

    let isOpen = false
    const closeVideo = () => {
      isOpen = false
      document.body.classList.remove('blur')
      vidCnt.style.display = 'none'
      iframe.src = ''
      overlay.removeEventListener('click', closeVideo)
      close.removeEventListener('click', closeVideo)
    }
    const openVideoRT = (videoId: string, videoHash: string) => {
      isOpen = true
      const width = document.documentElement.clientWidth
      if (width && width < 960) {
        window.open(
          `https://rutube.ru/video/private/${videoId}/?p=${videoHash}`,
          '_blank'
        )
        return
      }
      document.body.classList.add('blur')
      overlay.addEventListener('click', closeVideo)
      close.addEventListener('click', closeVideo)
      const link = `https://rutube.ru/play/embed/${videoId}/?p=${videoHash}&autoplay=1`
      vidCnt.style.display = 'block'
      iframe.src = link
      iframe.allow = 'accelerometer; autoplay'
    }
    document.addEventListener('keyup', e => {
      if (isOpen && e.key === 'Escape') {
        closeVideo()
      }
    })
    const wrapVideoBtn = (
      el: HTMLElement,
      videoId: string,
      videoHash: string
    ) => {
      const wrapper = document.createElement('div')
      wrapper.classList.add('video-button')
      el.after(wrapper)
      el.remove()
      wrapper.appendChild(el)
      wrapper.addEventListener('click', () => openVideoRT(videoId, videoHash))
    }
    const figures = document.querySelectorAll('figure')
    for (const fig of Util.iter(figures)) {
      const img = fig.querySelector('img')
      const a = fig.querySelector('a')
      if (!img || !a) {
        continue
      }

      const parsedUrl = new URL(a.href)
      const rtVideo = extractVideoIdAndHash(parsedUrl.href)

      wrapVideoBtn(img, rtVideo.videoId, rtVideo.hash)
    }
    const videoButtons = document.querySelectorAll<HTMLElement>('[data-vk]')
    for (const btn of Util.iter(videoButtons)) {
      const videoId = btn.dataset.rt
      const videoHash = btn.dataset.hash
      wrapVideoBtn(btn, videoId, videoHash)
    }

    const videoLinks = document.querySelectorAll<HTMLElement>('[data-vk-link]')

    for (const link of Util.iter(videoLinks)) {
      const videoId = link.dataset.youtubeLink
      const videoHash = link.dataset.youtubeHash
      link.addEventListener('click', () => openVideoRT(videoId, videoHash))
    }

    const hash = location.hash.split('#').pop()
    if (hash) {
      const elem = document.getElementById(hash)
      if (elem) {
        const videoId = elem.dataset.rt
        const videoHash = elem.dataset.hash
        if (videoId) {
          openVideoRT(videoId, videoHash)
        }
      }
    }
  }

  private static addSurvey(): void {
    document.addEventListener('DOMContentLoaded', () => {
      const likeButton = document.getElementById('like-button')
      const dislikeButton = document.getElementById('dislike-button')
      const surveyQuestions = document.getElementById('survey-questions')
      const surveyResults = document.getElementById('survey-results')

      if (likeButton && dislikeButton && surveyQuestions && surveyResults) {
        likeButton.addEventListener('click', () => {
          surveyQuestions.style.display = 'none'
          surveyResults.style.display = 'block'
          void Tracking.send(
            TrackingEvent.projectManagementCourseLikeButtonClick
          )
        })

        dislikeButton.addEventListener('click', () => {
          surveyQuestions.style.display = 'none'
          surveyResults.style.display = 'block'
          void Tracking.send(
            TrackingEvent.projectManagementCourseDislikeButtonClick
          )
        })
      }
    })
  }

  private static initializeAccordion(): void {
    const style = document.createElement('style')
    style.innerHTML = `
      * {
        scroll-behavior: auto !important;
      }
    `
    document.head.appendChild(style)

    document
      .querySelectorAll('.accordion')
      .forEach((accordion: HTMLElement) => {
        const openButton: HTMLElement = accordion.querySelector('.heading-open')
        const closeButton: HTMLElement =
          accordion.querySelector('.heading-close')

        const openButtonRect = openButton.getBoundingClientRect()
        openButton.dataset.initPos = openButtonRect.top.toString()

        // Open Button click
        openButton.addEventListener('click', () => {
          let descSummaryHeight = 0
          document
            .querySelectorAll('.description-wrapper')
            .forEach((desc: HTMLElement) => {
              console.log(desc.getBoundingClientRect().height)
              descSummaryHeight =
                Number(desc.getBoundingClientRect().height) + descSummaryHeight
            })

          openButton.dataset.windowPos = window.scrollY.toString()
          openButton.dataset.descHeight = descSummaryHeight.toString()

          document
            .querySelectorAll('.description-wrapper')
            .forEach((desc: HTMLElement) => {
              if (desc.dataset.id === openButton.dataset.id) {
                if (desc.style.display === 'block') {
                  desc.style.display = 'none'
                } else {
                  desc.style.display = 'block'
                }
              } else {
                desc.style.display = 'none'
              }
            })

          const winPos = Number(openButton.dataset.windowPos)
          const descHeight = Number(openButton.dataset.descHeight)

          if (winPos !== 0 && descHeight !== 0 && winPos > descHeight) {
            window.scrollTo({top: winPos - descHeight})
          } else {
            window.scrollTo({top: winPos})
          }
        })

        // Close Button click
        closeButton.addEventListener('click', () => {
          document
            .querySelectorAll('.description-wrapper')
            .forEach((desc: HTMLElement) => {
              desc.style.display = 'none'
            })

          const winPos = Number(openButton.dataset.windowPos)
          const descHeight = Number(openButton.dataset.descHeight)

          if (winPos !== 0 && descHeight !== 0 && winPos > descHeight) {
            window.scrollTo({top: winPos - descHeight})
          } else {
            window.scrollTo({top: winPos})
          }
        })

        // window.addEventListener('scroll', () => {
        //   console.log(window.scrollY.toString())
        // })
      })
  }

  static start(): void {
    TrainingController.addVideoPopup()
    TrainingController.addExpandImage()
    TrainingController.addSurvey()
    TrainingController.initializeAccordion()
  }
}

function extractVideoIdAndHash(url: string) {
  const videoIdPattern = /play\/embed\/([a-f0-9]+)/
  const hashPattern = /\?p=([a-zA-Z0-9]+)/

  const videoIdMatch = url.match(videoIdPattern)

  const hashMatch = url.match(hashPattern)

  const videoId = videoIdMatch ? videoIdMatch[1] : null
  const hash = hashMatch ? hashMatch[1] : null

  return {videoId, hash}
}
